import { render } from "./AquaparkRule.vue?vue&type=template&id=ff82764c"
import script from "./AquaparkRule.vue?vue&type=script&lang=js"
export * from "./AquaparkRule.vue?vue&type=script&lang=js"

import "./AquaparkRule.vue?vue&type=style&index=0&id=ff82764c&lang=scss"

import exportComponent from "/var/www/sanremo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__